import { BaseContainerModel } from '../base-container.model';
import { bl_ocr_branch_hdr_RowClass } from '../../dbschema';

export class OCRBranchContainerModel extends BaseContainerModel {
  bl_ocr_branch_hdr: bl_ocr_branch_hdr_RowClass = new bl_ocr_branch_hdr_RowClass();
}
